import { GreyGrey30, Flex } from '@sequencehq/core-components'
import { InputSelectControlField } from '@sequencehq/core-components'
import { useExternalLedgerForm } from './useExternalLedgerForm'

export const ExternalLedgerForm = () => {
  const { fieldsConfig } = useExternalLedgerForm()

  if (fieldsConfig.integrations.length === 0) {
    return null
  }

  return (
    <Flex
      flexDirection="column"
      gap="16px"
      width="100%"
      borderTop={`1px solid ${GreyGrey30}`}
      paddingTop="24px"
    >
      {fieldsConfig.integrations.map(integrationField => (
        <InputSelectControlField
          key={integrationField.id}
          label={integrationField.label}
          data-testid={`integration-${integrationField.id}`}
          value={integrationField.value}
          onChange={integrationField.onChange}
          options={integrationField.options}
          validationErrors={integrationField.validationErrors}
          disabled={integrationField.disabled}
          placeholder={`Choose ${integrationField.label}`}
        />
      ))}
    </Flex>
  )
}
